module.exports = __webpack_public_path__ + "static/tooltipYes-bcd0c2a6f61d298f06a43a0ffb66b5b1.png";